import { forwardRef } from "react";
import { Link, type LinkProps } from "react-router-dom";

import { useLocaleNavigation } from "../hooks/use-locale-navigation";

/**
 * Locale-aware Link component
 * Automatically prefixes the 'to' prop with current locale if on a locale-prefixed route
 * forwardRef: Radix DropdownMenuItem (Slot) merges a ref onto its child — plain function components reject refs.
 */
export const LocaleLink = forwardRef<HTMLAnchorElement, LinkProps>(function LocaleLink(
  { to, ...props },
  ref,
) {
  const { getLocalePath } = useLocaleNavigation();

  const localeTo = typeof to === "string" ? getLocalePath(to) : to;

  return <Link ref={ref} to={localeTo} {...props} />;
});
